import React, { useState, useContext, useEffect } from 'react';
import './dashboard.css';
import CounsellorSidebar from '../sidebar/sidebar';
import { AuthContext } from '../../../auth'
import { Redirect } from 'react-router-dom';
import Parse from 'parse'
import { Link } from 'react-router-dom'

const CounsellorDashboard = () => {

    const [degree, setDegree] = useState("");
    const [name, setName] = useState("");
    const [expereince, setExperience] = useState("");
    const [bio, setBio] = useState("");
    let [logedinuser, setLogedinuser] = useContext(AuthContext);
    let [patients, setPatients] = useState([])

    // previous code active cases displayed of all the users to whom counsellor is appointed to
    //vansh
    // useEffect(() => {
        
    //     const User = Parse.Object.extend("User");
    //     const query = new Parse.Query(User);

    //     query.equalTo("counsellor", logedinuser).find().then((patients) => {
    //         console.log(patients);
    //         setPatients(patients);
    //         const query = new Parse.Query(User);
    //         query.get(logedinuser).then((counsellor) => {
    //             setName(counsellor.get("name"));
    //             setDegree(counsellor.get("degree"));
    //             setExperience(counsellor.get("experience"));
    //             setBio(counsellor.get("bio"));
    //         })

    //     })

    // }, [])

    // previous code ends vansh



    //new active cases patients retrieved from users who have a profile ansh
    useEffect(() => {
        
        const UserProfile = Parse.Object.extend("UserProfile");
        const query = new Parse.Query(UserProfile);

        query.equalTo("counsellor_id", logedinuser).find().then((patients) => {
            console.log(patients);
            setPatients(patients);
            const User = new Parse.Object.extend("User");
            const query = new Parse.Query(User);
            query.get(logedinuser).then((counsellor) => {
                setName(counsellor.get("name"));
                setDegree(counsellor.get("degree"));
                setExperience(counsellor.get("experience"));
                setBio(counsellor.get("bio"));
            })

        })

    }, [])
    //new active cases ends ansh

    



    // console.log(activechats);
    return (

        <React.Fragment>
            <CounsellorSidebar head="Patient Profiles"></CounsellorSidebar>
            {console.log(logedinuser)}
            {(logedinuser == null) && (
                <Redirect to="/counsellor/login" />
            )}
            <div className="container mt-1" style={{ fontFamily: "'Open Sans', open-serif" }}>
                <div className="row ">
                    <div className="col-12 text-center">
                        <img src="/assests/images/user.png" className="rounded-circle" height="100" alt=""></img>
                    </div>
                    <div className="col-12 text-center mt-0">
                        <p className="mt-2 docname mb-0">Dr. {name} </p>
                        <p className="text-muted mb-1">Degree : {degree}</p>
                        <p className="text-muted mb-1">Experience : {expereince}</p>
                        <p className="text-muted mb-1">Bio : {bio}</p>
                        <Link to="/counsellor/profile" ><button type="button" className="btn" style={{ border: "1px solid #65cdf0" }}>Edit Profile</button></Link>
                        <hr></hr>
                    </div>
                </div>
                <div className="row">
                    <div className="col text-center">
                        <h4 className="mb-0" style={{ color: "#65cdf0" }}>Active Cases</h4>
                        <div class="title-underline" style={{ background: "#65cdf0", marginBottom: "4%" }}></div>
                    </div>
                </div>
                <div className="row justify-content-center">
                <div className="col-12 col-md-6 patientprofiles">
                        
                        {patients.map(patient => {
                            return (
                                <div className="card" key={patient.get("user_id")}>
                                    <div className="card-body">
                                        <div class="media" >
                                            <img class="mr-3" src="/assests/images/user.png" height="30" alt="" />
                                            <div class="media-body">
                                                <h5 class="my-0">Relation: {patient.get("relationship")}</h5>
                                                <p>{patient.get("user_id")}</p>
                                                {/* <i className="fas fa-comment fa-2x mr-5" style={{ color: "#65cdf0" }}></i> */}
                                                <div className="row">
                                                <Link to={`/counsellor/patient/${patient.get("user_id")}`}>
                                                    <i class="fas fa-file-alt fa-2x" style={{ color: "#65cdf0" }}></i>
                                                </Link>

                                                

                                                </div>

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}


                    </div>
                </div>

            </div>
        </React.Fragment>
    )
}

export default CounsellorDashboard;